import { Button, ButtonProps } from "@commonlibs";
import { UseShareParams, useShare } from "@commonlibs";
import clsx from "clsx";

export interface ShareButtonProps extends Omit<ButtonProps, "onClick">, UseShareParams {
    shareData: ShareData;
    renderWhenCantShare?: boolean;
}

function ShareButton({ className, onShare, onShareFailed, shareData, loading, renderWhenCantShare = true, ...rest }: ShareButtonProps) {
    const { share, isSharing, canShare } = useShare({ onShare, onShareFailed });

    async function handleClick() {
        await share(shareData);
    }

    const shouldRender = renderWhenCantShare || canShare(shareData);

    const fragment = (
        <>
            {shouldRender && (
                <Button
                    className={clsx("share-button", className)}
                    onClick={handleClick}
                    loading={isSharing || loading}
                    {...rest}
                />
            )}
        </>
    );

    return fragment;
}

export default ShareButton;
